/* eslint-disable global-require, import/no-mutable-exports */
import { DEBUG } from '@/scripts/stage/constants';

let gui;

if (DEBUG) {
  const { GUI } = require('dat.gui');

  gui = new GUI();
} else {
  gui = '';
}

export default gui;
